import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './hero91.css'

const Hero91 = (props) => {
  return (
    <div id={props.hero91Id} className="hero91-header30 thq-section-padding">
      <img
        alt="fitness"
        sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
        src="/fitnes3-1500w.webp"
        srcSet="/fitnes3-1500w.webp 1200w, /fitnes3-tablet.webp 800w, /fitnes3-mobile.webp 480w"
        className="hero91-image"
      />
      <div className="hero91-container"></div>
      <div className="hero91-max-width thq-section-max-width">
        <div className="hero91-content">
          <h2 className="hero91-text10 thq-heading-1">
            {props.heading1 ?? (
              <Fragment>
                <span className="hero91-text18">Otevírací doba</span>
              </Fragment>
            )}
          </h2>
          <h2 className="hero91-text11">
            {props.content1 ?? (
              <Fragment>
                <span className="hero91-text16">Po - Pá</span>
              </Fragment>
            )}
          </h2>
          <span className="hero91-text12">
            {props.text ?? (
              <Fragment>
                <span className="hero91-text15">6:00 - 22:00</span>
              </Fragment>
            )}
          </span>
          <h2 className="hero91-text13">
            {props.heading ?? (
              <Fragment>
                <span className="hero91-text19">víkendy + svátky</span>
              </Fragment>
            )}
          </h2>
          <span className="hero91-text14">
            {props.text1 ?? (
              <Fragment>
                <span className="hero91-text17">07:00 - 21:00</span>
              </Fragment>
            )}
          </span>
        </div>
      </div>
    </div>
  )
}

Hero91.defaultProps = {
  text: undefined,
  content1: undefined,
  text1: undefined,
  heading1: undefined,
  heading: undefined,
  hero91Id: '',
}

Hero91.propTypes = {
  text: PropTypes.element,
  content1: PropTypes.element,
  text1: PropTypes.element,
  heading1: PropTypes.element,
  heading: PropTypes.element,
  hero91Id: PropTypes.string,
}

export default Hero91
